module.exports = __webpack_public_path__ + "img/4.8a18595c.png";